import { useWorkspace } from '@/hooks/useWorkspace';

// Utility hook for single company check
export const useSingleCompanyMode = () => {
  const { hasMultipleCompanies } = useWorkspace();
  return !hasMultipleCompanies;
};

// Utility hook to get current company personas
export const useCurrentCompanyPersonas = () => {
  const { companyPersonas, isLoadingPersonas } = useWorkspace();
  return { personas: companyPersonas, isLoading: isLoadingPersonas };
};